import { Box, Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import AuthService from "../../../../AuthService.js";
import Card from "../Card/Card";
import CardBody from "../Card/CardBody.js";
import CardHeader from "../Card/CardHeader.js";
import GridContainer from "../Grid/GridContainer.js";
import Table from "../Table/Table.js";

import {
  grayColor,
  whiteColor,
} from "../../assets/jss/material-dashboard-react.js";

export default function ListDashboard({ periodo, tipoPedido }) {
  const filter =
    (periodo.dataInicial
      ? "/" + periodo.dataInicial + "/" + periodo.dataFinal
      : "") +
    "/" +
    tipoPedido;

  return (
    <GridContainer>
      <Box width="100%" padding="2rem">
        <CardGenerico
          title="Cupom de desconto utilizados"
          color="rose"
          url={`/dashboard/list/CUPOM_QUANTIDADE${filter}`}
        />
      </Box>
    </GridContainer>
  );
}

function CardGenerico({ color, title, url }) {
  const [informacao, setinformacao] = useState(null);
  const [loading, setLoading] = useState(true);

  function getInfo() {
    setLoading(true);
    const service = new AuthService();
    service
      .get(url)
      .then((resp) => {
        setinformacao(resp);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }

  useEffect(() => {
    getInfo();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    getInfo();
    //eslint-disable-next-line
  }, [url]);

  return (
    <Card>
      <CardHeader color={color}>
        <Box display="flex" justifyContent="center">
          <Box
            component="h3"
            sx={{
              color: whiteColor,
              marginTop: 0,
              minHeight: "auto",
              fontWeight: 300,
              fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
              marginBottom: "3px",
              textDecoration: "none",
              "& small": {
                color: grayColor[1],
                fontWeight: 400,
                lineHeight: 1,
              },
            }}
          >
            {title}
          </Box>
        </Box>
      </CardHeader>
      <CardBody>
        {loading ? (
          <Box sx={{ padding: "1rem", marginTop: "1.5rem" }}>
            <Skeleton variant="rectangular" height={30} sx={{ mb: "1rem" }} />
            <Skeleton variant="rectangular" height={30} sx={{ mb: "1rem" }} />
            <Skeleton variant="rectangular" height={30} />
          </Box>
        ) : (
          <Table
            tableHeaderColor="gray"
            tableHead={informacao?.head}
            tableData={informacao?.rows}
          />
        )}
      </CardBody>
    </Card>
  );
}
